if (!customElements.get("gift-card-discount-calc"))
  customElements.define(
    "gift-card-discount-calc",
    class GiftCardDiscountCalc extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {

        const targetNode = document.getElementById("gift-card-discount-code");
        const allowList = this.dataset.allowList.split(",").filter(Boolean);
        const observer = new MutationObserver((mutationList) => {
          for (const mutation of mutationList) {
            if (mutation.type === "childList") {
              const appliedDiscountCode = targetNode?.textContent || null
              if(appliedDiscountCode) {
                const isInAllowList = allowList.includes(appliedDiscountCode)
                if(isInAllowList) {
                  this.style.display = "block"
                  this.classList.add("show")
                }
              }
            } 
          }
        });
        observer.observe(targetNode, { attributes: true, childList: true, subtree: true });

        const variantSelector = document.querySelector("variant-radios") as any
        const allPrices = document.querySelectorAll("gift-card-discount-calc calc-prices");
        allPrices.forEach((price: any) => {
         if(variantSelector?.currentVariant?.price) price.dataset.value = variantSelector.currentVariant.price;
        })

        const appliedDiscountCode = targetNode?.textContent || null;
        if(appliedDiscountCode) {
          const isInAllowList = allowList.includes(appliedDiscountCode)
          if(isInAllowList) {
            this.style.display = "block"
            this.classList.add("show")
          }
        }
      }
    }
  );
